import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#060A24] border-t border-white/10 mt-0" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <img src="/brand/freddy-symbol.webp" alt="Freddy" className="h-8 w-auto" />
            <span className="text-white font-black tracking-[0.18em] text-xs">
              FREDDY COMPUTE
            </span>
          </div>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs">
            Where automotive dealers learn to build with AI. Premium programs taught
            by operators who have done it in real stores.
          </p>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm tracking-[0.18em]">LEARN</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/courses" className="hover:text-white">All Courses</Link></li>
            <li><Link to="/category/marketing" className="hover:text-white">Marketing</Link></li>
            <li><Link to="/category/sales" className="hover:text-white">Sales</Link></li>
            <li><Link to="/category/service" className="hover:text-white">Service</Link></li>
            <li><Link to="/category/operations" className="hover:text-white">Operations</Link></li>
            <li><Link to="/category/executive-mindset" className="hover:text-white">Executive Mindset</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm tracking-[0.18em]">ACCOUNT</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
            <li><Link to="/login" className="hover:text-white">Login</Link></li>
            <li><Link to="/register" className="hover:text-white">Register</Link></li>
            <li><Link to="/forgot-password" className="hover:text-white">Forgot password</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4 text-sm tracking-[0.18em]">COMPANY</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><span className="text-white/40">About · soon</span></li>
            <li><span className="text-white/40">Contact · soon</span></li>
            <li><span className="text-white/40">Terms · soon</span></li>
            <li><span className="text-white/40">Privacy · soon</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40 tracking-wider">© 2026 Freddy Compute. All rights reserved.</p>
          <p className="text-xs text-white/40 tracking-wider">Built for the AI-first dealer.</p>
        </div>
      </div>
    </footer>
  );
}
